import React, { useState } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { Upload } from '@e3dc-react/shell/Elements/FileTransfer'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TextField } from '@e3dc-react/shell/Elements/InputFields'
import { useTypedSelector } from 'src/State/RootReducer'
import useInstallationFiles from 'src/Libs/documents/hooks/use-installation-files'
import { Stack } from '@mui/material'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'

export interface InstallationDocumentUpload {
  installationId: number
  onClose: () => void
  place: number
}

const InstallationDocumentUploadModal: React.FC<InstallationDocumentUpload> = ({ onClose }) => {
  const { t } = useCustomTranslation()
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [uploadedFile, setUploadFile] = useState<Blob>()
  const { uploadInstallationFile } = useInstallationFiles()
  const activeInstallation = useTypedSelector(state => state.storage.activeInstallation)

  const { snackError } = useSnackbar()

  const handleNameChange = (value: string): void => {
    setName(value)
  }

  const handleDescriptionChange = (value: string): void => {
    setDescription(value)
  }

  const handleSaveDocument = (): void => {
    if (uploadedFile) {
      const formData = new FormData()
      formData.append('file', uploadedFile)
      formData.append('name', name)
      formData.append('description', description)
      uploadInstallationFile(activeInstallation, formData).catch(snackError)
    }
  }

  const filesDropped = (file: Blob): void => {
    setUploadFile(file)
  }

  return (
    <Dialog
      title={t('dashboard.documents.UploadDocumentTitle')}
      onClose={onClose}
      actions={{
        primary: {
          name: t('common.save'),
          onClick: () => {
            handleSaveDocument()
            onClose()
          },
        },
        secondary: { name: t('common.cancel') },
      }}
      maxWidth="sm"
    >
      <Stack direction={'column'} spacing={2} sx={{ py: 1 }}>
        {/* TODO: refactor to formik version */}
        <TextField label={t('common.name')} name="name" onChange={(value: string) => handleNameChange(value)} value={name || ''} />
        <TextField
          label={t('common.description')}
          name="description"
          onChange={(value: string) => handleDescriptionChange(value)}
          value={description || ''}
        />
        <Upload onFilesDropped={filesDropped} />
      </Stack>
    </Dialog>
  )
}

export default InstallationDocumentUploadModal
